import {Model} from "./model";
import {Audience} from "./audience";
import {User} from './user';
import {NamedItem} from '../pipes/array-name-join.pipe';
import { AiReportSummary, AiReportSummaryStatus } from "./ai-report-summary";

export class Project implements Model, NamedItem {
  id: number;
  user?: User;
  name: string;
  _owner?: boolean; // If logged user is owner or not
  _shared_info?: boolean; // ?
  _ready?: boolean = false; // If project is loaded and ready
  flag?: string; // Crawl flag system
  newCrawl?: boolean; // New crawl toggle
  audience_target: Audience;
  audience_bench: Audience;
  report_ready?: boolean;
  source_type?: string;
  persona_merge_mode?: string;
  shared_users?: User[];
  created_at?: Date;
  updated_at?: Date;
  _insights_summary?: AiReportSummary;
  _insights_summary_status?: AiReportSummaryStatus;
  _inspirational_content?: AiReportSummary;
  _inspirational_content_status?: AiReportSummaryStatus;

  constructor(name: string) {
    this.name = name;
  }
}
